import { JSONSchemaType } from 'ajv'

export interface IStateFormData {
  countryId: string
  name: string
}

const StateSchema: JSONSchemaType<IStateFormData> = {
  type: 'object',
  properties: {
    countryId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
  },
  required: ['countryId', 'name'],
  additionalProperties: false,
}

export default StateSchema
